import PurchaseOrder from '@/classes/purchaseOrder';

const state = {
  purchaseOrders: [],
};

const getters = {
  addon: (state) => state.purchaseOrders.filter(po => po.purchaseOrderType === 'Add On' || po.purchaseOrderType === 'Extension'),
  all: (state) => state.purchaseOrders.sort((a, b) => a.order - b.order),
  get: (state) => state.purchaseOrders.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {}),
  rootAddon: (state, getters) => getters.addon.filter(po => !po.parentId),
  simulation: (state, getters) => getters.all.filter(po => po.purchaseOrderType === 'Test Simulation'),
  subscription: (state, getters) => getters.all.filter(po => po.purchaseOrderType === 'Subscription'),
  tieredPricing: (state, getters) => getters.all.filter(po => po.purchaseOrderType === 'Tiered Pricing' && !po.isFree),
  web: (state, getters) => getters.all.filter(po => po.showOnWeb),
};

const mutations = {
  set(state, purchaseOrders) {
    state.purchaseOrders = purchaseOrders.map(po => new PurchaseOrder(po));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
